module.exports = __webpack_public_path__ + "static/media/hearts-jack.5ed4e086.png";